import { LoadingProgress, LoadingWrapper } from "./LoadingIndicator.styles";
import { LoadingIndicatorProps } from "./LoadingIndicator.props";

export const LoadingIndicator = ({ size }: LoadingIndicatorProps) => (
  <LoadingWrapper>
    <LoadingProgress size={size} disableShrink />
  </LoadingWrapper>
);
